import {
  AnchoredPanelType,
  InputFormSidePanel,
  InputFormSidePanelProps,
  TextInput,
  TextInputMultilineConfig,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";

export const enum Fields {
  Comments = "comments",
}

export interface SupportUpdatePanelProps extends Pick
  <InputFormSidePanelProps, "componentRef" | "onClose" | "onSubmit" | "title" | "submitText"> {
  targetId: string,
}

export const SupportUpdatePanel = ({
  targetId,
  title,
  componentRef,
  onSubmit,
  onClose,
  submitText,
}: SupportUpdatePanelProps): JSX.Element => (
  <InputFormSidePanel
    submitText={submitText}
    componentRef={componentRef}
    anchorId={targetId}
    type={AnchoredPanelType.MEDIUM}
    title={title}
    onSubmit={onSubmit}
    onClose={onClose}
  >
    <TextInput
      label={Messages.labels.comments()}
      fieldName={Fields.Comments}
      required
      multiline={{ rows: 10 } as TextInputMultilineConfig}
    />
  </InputFormSidePanel>
);
